import { FormCard, FormItem, Input } from '@lmc/ui-kit'
import {
  EMAIL_MAX_LENGTH,
  NAME_MAX_LENGTH,
  RELATIONSHIP_MAX_LENGTH,
  TELEPHONE_MAX_LENGTH
} from 'common/constants'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'

type DependantContactFormSectionProps = {
  testId?: string
}

const DependantContactFormSection = ({
  testId
}: DependantContactFormSectionProps) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  const baseTest = testId ? `${testId}-dependant` : 'dependant'

  return (
    <FormItem
      noStyle
      shouldUpdate={(prev, curr) => prev?.isDependant !== curr?.isDependant}
    >
      {({ getFieldValue }) => {
        const isDependant = getFieldValue('isDependant') === true
        if (!isDependant) {
          return null
        }

        return (
          <FormCard
            title={t(supConstants.LINKED_CONTACT_DETAILS_TITLE)}
            subtitle={t(supConstants.LINKED_CONTACT_DETAILS_SUBTITLE)}
            data-testid={
              testId ? `${testId}-dependant-form-card` : 'dependant-form-card'
            }
          >
            <FormItem
              preserve={false}
              rules={[
                {
                  max: NAME_MAX_LENGTH,
                  message: t(supConstants.FIRST_NAME_MAX_LENGTH)
                }
              ]}
              label={t(supConstants.FIRST_NAME)}
              name={['dependantDetails', 'linkedContactName', 'first']}
            >
              <Input
                maxLength={NAME_MAX_LENGTH}
                data-testid={`${baseTest}-linked-first-name`}
              />
            </FormItem>
            <FormItem
              preserve={false}
              rules={[
                {
                  max: NAME_MAX_LENGTH,
                  message: t(supConstants.LAST_NAME_MAX_LENGTH)
                }
              ]}
              label={t(supConstants.LAST_NAME)}
              name={['dependantDetails', 'linkedContactName', 'last']}
            >
              <Input
                maxLength={NAME_MAX_LENGTH}
                data-testid={`${baseTest}-linked-last-name`}
              />
            </FormItem>
            <FormItem
              preserve={false}
              label={t(supConstants.DEPENDANT_LINKED_CONTACT_RELATIONSHIP)}
              name={['dependantDetails', 'linkedContactRelationship']}
            >
              <Input
                maxLength={RELATIONSHIP_MAX_LENGTH}
                data-testid={`${baseTest}-linked-relationship`}
              />
            </FormItem>
            <FormItem
              preserve={false}
              label={t(supConstants.TELEPHONE1)}
              name={['dependantDetails', 'linkedContactTelephone']}
            >
              <Input
                maxLength={TELEPHONE_MAX_LENGTH}
                data-testid={`${baseTest}-linked-tel1`}
              />
            </FormItem>
            <FormItem
              preserve={false}
              label={t(supConstants.TELEPHONE2)}
              name={['dependantDetails', 'linkedContactTelephoneSecondary']}
            >
              <Input
                maxLength={TELEPHONE_MAX_LENGTH}
                data-testid={`${baseTest}-linked-tel2`}
              />
            </FormItem>
            <FormItem
              preserve={false}
              label={t(supConstants.EMAIL)}
              name={['dependantDetails', 'linkedContactEmail']}
            >
              <Input
                type="email"
                name="linkedContactEmail"
                maxLength={EMAIL_MAX_LENGTH}
                data-testid={`${baseTest}-linked-email`}
              />
            </FormItem>
          </FormCard>
        )
      }}
    </FormItem>
  )
}

export default DependantContactFormSection
